module.exports = ".width-150px {\n  width: 150px; }\n\n.width-210px {\n  width: 210px; }\n\n.width-300px {\n  width: 300px; }\n\n.width-335px {\n  width: 335px; }\n\n#OpcDesc {\n  padding-bottom: 1%; }\n\n.container {\n  max-width: 98%; }\n\n.col-3 {\n  max-width: 33%; }\n\n.col-2 {\n  max-width: 23%; }\n\n#titulo {\n  padding-top: 1%; }\n\n#btnBuscar {\n  height: 37px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/complement-loaded/complement-loaded.component.scss
// module id = ./src/app/pages/complement-loaded/complement-loaded.component.scss
// module chunks = main